import { IonBackButton, IonButton, IonButtons, IonCol, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonListHeader, IonPage, IonRow, IonSelect, IonSelectOption, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react'
import { addCircleOutline } from 'ionicons/icons'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import db from '../../resources/db'

const Expenses = () => {

    const [expenses, setExpenses] = useState([])
    const [description, setDescription] = useState('');
    const [type, setType] = useState('Services');
    const [amount, setAmount] = useState(0);
    const [date, setDate] = useState(Date());

    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        db.getExpenses().then(expense => {
            setExpenses(expense);
        })
        return () => {
            setExpenses([]);
        }
    }, [])

    const clearAll = () => {
        setType('');
        setAmount(0);
        setDescription('');
        setDate(new Date());
    }

    const addExpense = (e) => {
        e.preventDefault();
        const item = {
            date: moment(date).format('ll'),
            amount: parseFloat(amount),
            expenseType: type,
            description
        }

        const ledger = {
            customerName: "Expenses",
            customerGST: "",
            customerDetails: item.description,
            customerContact: '',
            date: item.date,
            debit: parseFloat(item.amount),
            credit: parseFloat(0),
            receivable: parseFloat(0),
            payable: 0,
            isCustomer: 1, //true
            editable: false,
        }
        ledger.cash = ledger.credit - ledger.debit

        db.db.transaction('rw', db.expenses, db.ledger, () => {
            db.expenses.put(item).then((r) => {
                console.log(r, 'Item added');
                setExpenses((prev) => [...prev, item]);
            });
            db.ledger.put(ledger);
        }).then((r) => {
            console.log(r);
            setShowForm(false);
            clearAll();
        })
        setShowForm(false);

    }

    let subTotal = 0;
    if (expenses.length) {
        subTotal = expenses.reduce((sum, product) => {
            let totalsum = sum + product.amount;
            return totalsum
        }, 0)
    }

    const EXPENSE = () => expenses.map((item, index) => (
        <IonItem key={index}  >
            <IonCol>{item.date}</IonCol>
            <IonCol>{item.description}</IonCol>
            <IonCol>{item.expenseType}</IonCol>
            <IonCol>{item.amount}</IonCol>
        </IonItem>
    ));

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Expenses</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>

                <h5>Total Expenses: Rs.{subTotal.toFixed(2)}</h5>
                <IonList className='ion-list'>
                    <IonListHeader>
                        <IonCol>Date</IonCol>
                        <IonCol>Description</IonCol>
                        <IonCol>Type</IonCol>
                        <IonCol>Amount</IonCol>
                    </IonListHeader>
                    <EXPENSE />
                </IonList>

                <IonButton fill='outline' color='danger' hidden={showForm} onClick={() => { setShowForm(true); }}>Add Expense</IonButton>

                <form onSubmit={addExpense} hidden={!showForm}>
                    <h2 style={{ color: 'red' }}>Add Expenses</h2>

                    <IonRow>
                        <IonCol><IonItem>
                            <IonLabel position='stacked'>Date</IonLabel>
                            <input type='date' id="date" value={moment(date).format('YYYY-MM-DD')} onChange={(e) => { setDate(e.target.value) }}></input>
                        </IonItem>
                        </IonCol>
                        <IonCol>
                            <IonItem>
                                <IonLabel position='floating' >Description</IonLabel>
                                <IonInput type='text' placeholder='Expense Description' value={description} onIonChange={e => setDescription((e.target.value).trim())} />
                            </IonItem>
                        </IonCol>

                        <IonCol>
                            <IonItem>
                                <IonLabel position='floating' >Type</IonLabel>
                                <IonSelect interface='popover' value={type} onIonChange={e => setType(e.target.value)} >
                                    <IonSelectOption value="HouseHold">HouseHold</IonSelectOption>
                                    <IonSelectOption value="Rental">Rental</IonSelectOption>
                                    <IonSelectOption value="Private">Private</IonSelectOption>
                                    <IonSelectOption value="Services">Services</IonSelectOption>
                                    <IonSelectOption value="Health">Health</IonSelectOption>
                                    <IonSelectOption value="Taxes">Taxes</IonSelectOption>
                                </IonSelect>
                            </IonItem>
                        </IonCol>
                        <IonCol>
                            <IonItem>
                                <IonLabel position='floating' >Amount</IonLabel>
                                <IonInput type='number' placeholder='Expense Amount' value={amount} onIonChange={e => setAmount((e.target.value))} />
                            </IonItem>
                        </IonCol>
                        <IonCol>
                            <IonButton fill='outline' type='submit' shape='round'>
                                <IonIcon icon={addCircleOutline} />
                            </IonButton>
                        </IonCol>
                    </IonRow>

                </form>


                {/* <IonFab vertical='bottom' horizontal='end' slot='fixed'>
                    <IonFabButton >
                        <IonIcon icon={addCircleOutline} />
                    </IonFabButton>
                </IonFab> */}
            </IonContent>
        </IonPage>
    )
}

export default Expenses
